import { fromSpecific, scope, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'
import * as RouterDOM from 'react-router-dom'

import type { ComponentNode, ComponentSpecific } from '../Component/TypedNode'
import type {
  CSSStyleSheetNode,
  CSSStyleSheetSpecific
} from '../CSSStyleSheet/TypedNode'
import type { PageNode, PageSpecific } from '../Page/TypedNode'
import type { QueryNode, QuerySpecific } from '../Query/TypedNode'
import type { VariableNode, VariableSpecific } from '../Variable/TypedNode'
import type { AppPlugin } from './plugin'
import type { TypedSpecificLike } from '@rehaje/core'
import type { TRecord } from '@rehaje/shared'
import type { Router } from '@remix-run/router'

export interface AppSpecific extends TypedSpecificLike {
  components?: ComponentSpecific[]
  pages?: PageSpecific[]
  resources?: Array<QuerySpecific | VariableSpecific>
  stylesheets?: CSSStyleSheetSpecific[]
  type: 'App'
}

@scope({
  type: 'Block'
})
export class AppNode extends TypedNode {
  @fromSpecific()
  @reactive('shallow')
  components: ComponentNode[] = []

  @fromSpecific()
  @reactive('shallow')
  pages: PageNode[] = []

  @fromSpecific()
  @reactive('shallow')
  queries: QueryNode[] = []

  @fromSpecific()
  @reactive('shallow')
  stylesheets: CSSStyleSheetNode[] = []

  @fromSpecific()
  @reactive('shallow')
  variables: VariableNode[] = []

  get plugin() {
    return this.getPlugin<AppPlugin>()
  }

  get router(): Router {
    return RouterDOM.createBrowserRouter(this.createRoutes(this.pages), {
      basename: this.plugin.props.basename
    }) as any
  }

  createRoutes(pages: PageNode[] = []): any[] {
    const routes = pages.map((page) => {
      const route: TRecord = {
        Component: () => page.render(),
        errorElement: this.plugin.props.errorElement,
        index: !!page.index,
        path: page.path
      }
      if (page.index === true) {
        delete route.path
      }
      if (page.children) {
        route.children = this.createRoutes(page.children)
      }
      return route
    })
    return routes
  }
}

declare global {
  export interface RehajeSpecifics {
    App: AppSpecific
  }
  export interface RehajeTypedNodes {
    App: AppNode
  }
}
